module.exports = __webpack_public_path__ + "assets/img/face_attribute_scene1.ed6d1540.png";